<template>
  <div>
    <transition name="slide">
      <div class="kvapp-main-container accesscontrol-role-main-container">
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="position-absolute pointer accesscontrol-backArrow">
            <img
              @click="$emit('close-review-cand')"
              src="../../assets/img/accessconnew/boxBackArrow.svg"
              alt
            />
          </div>
          <div v-if="isPending" class="addrole-heading ml-3 pt-1">
            Review Candidate
          </div>
          <div v-else class="addrole-heading ml-3 pt-1">Preview Candidate</div>
          <div class="rotate-on-hover pointer">
            <img
              v-b-tooltip.hover.top="'Close'"
              @click="$emit('close-review-cand')"
              src="../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />

        <div class="px-3 py-2 h-90 d-flex align-items-center">
          <div class="w-50 h-100">
            <div class="kvapp-left-container">
              <div class="kvapp-left-header d-flex align-items-center pl-2">
                Basic Details
              </div>
              <div class="kvapp-inner-container p-2">
                <div
                  v-for="(field, i) in customFieldsArray"
                  :key="field.key + i"
                >
                  <div
                    v-if="field.label !== 'Resume'"
                    class="w-100 d-flex align-items-center"
                    :class="i !== 0 ? 'mt-3' : ''"
                  >
                    <div class="newCand-basic-head" style="width: 40%">
                      {{ field.label }}
                    </div>
                    <div
                      class="newCand-basic-content text-truncate"
                      style="width: 60%; overflow-x: auto"
                    >
                      <div v-if="checkFieldKeys(field)">-</div>
                      <div
                        style="word-break: keep-all"
                        v-else-if="Object.keys(candDetails).length > 0"
                      >
                        <template v-if="isHtmlContent(field)">
                          <div v-html="checkValuesOfKey(field)"></div>
                        </template>
                        <template v-else>
                          {{ checkValuesOfKey(field) }}
                        </template>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div
                class="d-flex align-items-center pl-2 mt-2"
                v-if="
                  isBuilderProfileAvailable && roles.includes('GET_PROFILE')
                "
              >
                <img
                  @click="goToCandidateProfile"
                  src="../../assets/img/accessconnew/blueEye.svg"
                  alt="/"
                  class="pointer"
                />
                <div
                  class="newCand-view-font ml-2 pointer"
                  @click="goToCandidateProfile"
                >
                  View Candidate Profile
                </div>
              </div>
            </div>
          </div>
          <div class="w-50 h-100 kvapp-right-container ml-2">
            <div
              class="
                kvapp-left-header
                d-flex
                align-items-center
                px-2
                justify-content-between
              "
            >
              <div
                class="newCand-word-resume-font text-truncate"
                style="width: 85%"
              >
                <!-- {{
                      getFileName(
                        candDetails.resume
                          .substring(candDetails.resume.lastIndexOf("/") + 1)
                          .split("?")[0]
                          .replace(/%20/g, " ")
                      )
                    }} -->
                Resume
              </div>
              <div class="d-flex align-items-center">
                <img
                  class="pointer mr-3"
                  src="../../assets/newJD/newCand-download-icon.svg"
                  alt=""
                  @click="downloadFeedback(candDetails.resume)"
                />
                <img
                  v-b-modal.viewResume
                  class="pointer"
                  src="../../assets/newJD/newCand-previewresume-icon.svg"
                  alt=""
                />
              </div>
            </div>
            <hr class="my-1" />
            <div class="h-80 overflow-auto">
              <pdf
                class="h-100 w-100"
                ref="pdf"
                :src="candDetails.resume"
                :page="currentPage"
                @num-pages="numPages = $event"
                @link-clicked="currentPage = $event"
                @page-loaded="currentPage = $event"
              ></pdf>
            </div>
            <div class="w-100 viewResume-paginaTion-modal">
              <div class="pagination w-100 d-flex justify-content-center mt-2">
                <b-pagination
                  align="center"
                  first-number
                  last-number
                  v-model="currentPage"
                  :total-rows="numPages"
                  :per-page="perPage"
                >
                  <template #prev-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt
                      />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt
                      />
                    </span>
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <!-- view resume feedback start from here -->
    <b-modal id="viewResume" centered hide-footer hide-header size="lg">
      <div class="d-flex">
        <div class="viewResume-left-modal-back"></div>
        <div class="w-94">
          <div class="viewResume-modal-header">
            <div>Preview ATS Resume</div>

            <div>
              <img
                class="rotate-on-hover"
                src="../../assets/img/accessconnew/blueCross.svg"
                alt=""
                @click="$bvModal.hide('viewResume')"
              />
            </div>
          </div>
          <div
            class="d-flex flex-column align-items-center pt-2 pl-4 pr-4 pb-2"
          >
            <div class="viewResume-graph-overflow p-2">
              <div class="viewResume-Graph-modal-resume">
                <pdf
                  ref="pdf"
                  :src="candDetails.resume"
                  :page="currentPage"
                  @num-pages="numPages = $event"
                  @link-clicked="currentPage = $event"
                  @page-loaded="currentPage = $event"
                ></pdf>
              </div>
            </div>
            <div
              class="
                viewResume-paginaTion-modal
                align-items-center
                justify-content-center
                d-flex
                w-100
              "
            >
              <div class="pagination">
                <b-pagination
                  align="center"
                  v-model="currentPage"
                  :total-rows="numPages"
                  :per-page="perPage"
                  first-number
                  last-number
                >
                  <template #prev-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageleft.svg"
                        alt
                      />
                    </span>
                  </template>
                  <template #next-text>
                    <span>
                      <img
                        src="../../assets/img/accessconnew/pageright.svg"
                        alt
                      />
                    </span>
                  </template>
                </b-pagination>
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
    <!-- view resume feedback ends here -->
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { downloadFeedback } from "../../utils/download";
import {
  checkFieldKeys,
  isHtmlContent,
  checkValuesOfKey,
} from "../../utils/customFields";
import pdf from "vue-pdf";

export default {
  name: "ViewCandidateStatus",

  data() {
    return {
      // NUMBER
      currentPage: 1,
      numPages: 0,
      perPage: 1,

      // STRINGS
      remarks: "",
      decision: "",

      // BOOLEAN
      showFeedbackModal: false,
      singleFeedbackModal: false,

      // OBJECTS
      singleBasicInfo: {},
      singleFeedbackData: {},

      // ARRAYS
      particularJob: [],
      selecetdFeedbacks: [],
    };
  },
  filters: {
    formatDate(data) {
      let datePart = data.split("T")[0];
      let formattedDate = datePart.split("-").reverse().join("-");
      return formattedDate;
    },
  },
  components: {
    pdf,
  },
  computed: {
    ...mapGetters(["roles"]),
  },
  props: {
    openPreview: Boolean,
    isPending: Boolean,
    candDetails: Object,
    customFieldsArray: Array,
    isBuilderProfileAvailable: Boolean,
  },
  methods: {
    goToCandidateProfile() {
      this.$router.push({
        name: "PreviewOpsheadCandidateProfile",
        params: {
          email: this.candDetails.email,
        },
      });
    },

    // Feedback Modal Functions
    openFeedbackForm(round) {
      if (round.feedback.length > 1) {
        this.showFeedbackModal = true;
        this.selecetdFeedbacks = round.feedback;
      } else {
        this.singleFeedbackModal = true;
        this.singleFeedbackData = round.feedback[0];
        this.singleBasicInfo = {};
        this.singleBasicInfo["name"] = this.candDetails.name;
        this.singleBasicInfo["evalDate"] =
          this.singleFeedbackData.feedBackForm.createdAt;
        this.singleBasicInfo["panel"] =
          this.singleFeedbackData.feedBackForm.panelName;
        this.singleBasicInfo["modeOfInterview"] =
          this.singleFeedbackData.interviewRound.type;
        this.singleBasicInfo["action"] =
          this.singleFeedbackData.feedBackForm.recommendation;
        this.singleBasicInfo["remarks"] =
          this.singleFeedbackData.feedBackForm.recruiterRemarks;
        this.singleBasicInfo["feedback"] =
          this.singleFeedbackData.assessmentResponse;
      }
    },

    closeFeedbackModal() {
      this.showFeedbackModal = false;
    },

    closeSingleFeedbackModal() {
      this.singleFeedbackModal = false;
    },

    downloadFeedbackForm(link) {
      const candidateName = this.candDetails.name;
      const fileName = `${candidateName}.pdf`;
      const a = document.createElement("a");
      a.href = link;
      a.download = fileName;
      a.click();
    },

    // Custom Field Functions
    checkFieldKeys(field) {
      return checkFieldKeys(field, this.candDetails);
    },

    isHtmlContent(field) {
      return isHtmlContent(field, this.candDetails);
    },

    checkValuesOfKey(field) {
      return checkValuesOfKey(field, this.candDetails);
    },

    // Check document type for displaying resume
    isDocType(fileUrl) {
      return (
        fileUrl
          .substring(fileUrl.lastIndexOf("/") + 1)
          .split("?")[0]
          .toLowerCase()
          .endsWith(".doc") ||
        fileUrl
          .substring(fileUrl.lastIndexOf("/") + 1)
          .split("?")[0]
          .toLowerCase()
          .endsWith(".docx")
      );
    },

    getFileName(fileName) {
      if (fileName.length <= 30) {
        return fileName;
      } else {
        return fileName.slice(0, 30) + "...";
      }
    },

    downloadFeedback(url) {
      downloadFeedback(url);
    },
  },
};
</script>

<style scoped>
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.5s ease;
}

.slide-enter {
  transform: translateX(100%);
}

.slide-leave-to {
  transform: translateX(100%);
}
</style>
